
const _directiveDependencies = [];

class UserEventsDirective {

    constructor() {

        this.template = require('./user-events.html');
        this.restrict = 'EA';
        this.replace = true;

    }

}

_directiveDependencies.push(() => new UserEventsDirective());

angular.module('directives')
    .directive('userEvents', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/header/user-events/user-events.js